module.exports = __webpack_public_path__ + "static/media/bonk2.a045eecf.mp3";